import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import _ from 'lodash';
import moment from 'moment-timezone';

import { StatsAPI, FindingAPI, PostingAPI } from '../../lib/api';
import { settings } from '../../lib/settings';

import Safe from '../Components/Safe';
import Loading from '../Components/Loading';
import DateRangeSelection from '../Components/DateRangeSelection';
import CriteriaSelection from '../Components/CriteriaSelection';
import Flyout from '../Components/Flyout';
import FindingDetail from '../Components/FindingDetail';
import DataGrid from '../Components/DataGrid';

import video from '../../images/funnel_test.mp4';

const API = {
  stats: new StatsAPI(),
  events: new FindingAPI(),
  news: new PostingAPI(),
};

class EventsPageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollerOpen: settings.get('preferences.scrollerOpen', true),
      flyoutEvent: null,
    };

    this.fetch = this.fetch.bind(this);
    this.viewDetail = this.viewDetail.bind(this);
    this.closeDetail = this.closeDetail.bind(this);
    this.update = this.update.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    let fetch = false;
    if (prevProps.orgId !== this.props.orgId) {
      fetch = true;
    } else if (!_.isEqual(prevProps.payload, this.props.payload)) {
      fetch = true;
    }
    if (fetch) this.fetch();
  }

  fetch() {
    const { dispatch } = this.props;
    this.handleFetch().then((responses) => {
      dispatch({ type: 'PAGE_SUCCESS', responses });
    }).catch((error) => {
      dispatch({ type: 'PAGE_ERROR', error });
    });
  }

  async handleFetch() {
    const {
      dispatch,
      getState,
      orgId,
      user = {},
    } = this.props;

    const {
      role = 'anonymous',
    } = user;

    dispatch({ type: 'PAGE_FETCH' });

    const { filters = {} } = getState().page;
    const { selectionRange = {} } = filters;
    const { startDate, endDate } = selectionRange;

    const promises = [
      API.stats.get({
        orgId,
        role,
        startDate,
        endDate,
      }).then(({ data }) => {
        dispatch({ type: 'PAGE_DATA_PART', part: 'stats', data });
      }),
      API.events.get({
        personId: user.id,
        orgId: 'ffffffff-feed-beef-1337-c0ffee000001',
        role,
        startDate,
        endDate,
      }).then(({ data }) => {
        dispatch({ type: 'PAGE_DATA_PART', part: 'events', data });
      }),
    ];

    return Promise.all(promises);
  }

  update(data = {}) {
    const { dispatch } = this.props;
    const { events = [] } = this.props.data || {};
    const newEvents = events.slice();
    _.each(newEvents, (e, i) => {
      if (e._id === data._id) {
        newEvents[i] = data;
        if (this.flyoutEvent && this.flyoutEvent._id === data._id) {
          this.viewDetail(data);
        }
      }
    });
    // @TODO: make api request to update user in the db
    dispatch({ type: 'PAGE_DATA_PART', part: 'events', data: newEvents });
  }

  toggleScrollerOpen() {
    this.setState((state) => {
      settings.set('preferences.scrollerOpen', !state.scrollerOpen, true);
      return ({ scrollerOpen: !state.scrollerOpen });
    });
  }

  viewDetail(flyoutEvent) {
    this.setState({ flyoutEvent });
  }

  viewTimeline(event) {
    const { routeToPage, orgId } = this.props;
    routeToPage({
      payload: {
        orgId,
        toplevel: 'query',
        secondlevel: 'threats',
        id1: event._id,
      },
    });
  }

  closeDetail() {
    this.setState({ flyoutEvent: null });
  }

  render() {
    const {
      data = {},
      filters = {},
      applyFilter,
      loading = false,
      user = {},
      payload = {},
    } = this.props;

    const {
      role, // eslint-disable-line
    } = user;

    const {
      toplevel,
      secondlevel,
    } = payload;

    const {
      scrollerOpen,
      flyoutEvent = null,
    } = this.state;

    const {
      stats = {},
      events = [],
      assignableUsers = [{ // @TODO @XXX
        username: 'responder',
        firstname: 'Rey',
        lastname: 'Responda',
        role: 'responder',
      }, {
        username: 'analyst',
        firstname: 'Alice',
        lastname: 'Analysta',
        role: 'analyst',
      }, {
        username: 'analyst2',
        firstname: 'Alicia',
        lastname: 'Analysta',
        role: 'analyst',
      }, {
        username: 'analyst3',
        firstname: 'Alejandro',
        lastname: 'Analysto',
        role: 'analyst',
      }, {
        username: 'manager',
        firstname: 'Ollie',
        lastname: 'Operata',
        role: 'manager',
      }],
    } = data;

    let loadingStyles = {};
    if (loading) {
      loadingStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        marginTop: '50px',
      };
    }

    return (
      <span
        className='dashboard'
        style={{ ...loadingStyles }}
      >
        {loading &&
          <Loading />
        }
        {!loading &&
          <div style={{ position: 'relative' }}>
            <div className='page-header'>
              <span className='page-title' style={{ marginRight: '5px' }}>
                <h1>
                  <Safe
                    render
                    safe
                    path={`pages.${toplevel}.${secondlevel}`}
                    value='title'
                  />
                </h1>
              </span>
              <span className='page-description' style={{ fontSize: '0.6rem', marginTop: '5px' }}>
                <p>
| &nbsp;
                  <Safe
                    render
                    safe
                    path={`pages.${toplevel}.${secondlevel}`}
                    value='description'
                  />
                </p>
              </span>
            </div>
            <hr />
            <div className='row filters'>
              <div className='col-5 left-column' style={{ zIndex: 999 }}>
                <div className='column-header' style={{ marginBottom: '15px', display: 'none' }}>
                  <div className='uppercase'>Filters</div>
                  <i
                    className='fas fa-filter'
                    style={{ position: 'absolute', right: '15px', top: '5px' }}
                  />
                </div>
                <div className='filters'>
                  <DateRangeSelection
                    applyFilter={applyFilter}
                    fetch={this.fetch}
                    selectionRange={filters.selectionRange}
                  />
                </div>
              </div>
              <div className='col-5 middle-column'>
                <CriteriaSelection
                  applyFilter={applyFilter}
                  fetch={this.fetch}
                  criteria={filters.criteria}
                />
              </div>
              <div className='col-2 align-self-center right-column'>
                <div className='reports align-self-center'>
                  <div>
                    <a href='#download-report' target='_blank'>
Export Report
                      <i className='fas fa-share-square' />
                    </a>
                  </div>
                  <div>
                    <a href='#automatic-report' target='_blank'>
Create Automatic Report
                      <i className='fas fa-share-square' />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='scroller flex' data-open={scrollerOpen}>
              <video
                autoPlay
                muted
                loop
                id='scrollerVideo'
                style={{
                  opacity: 0.1,
                  position: 'absolute',
                  top: 0,
                  left: 0,
                }}
              >
                <source src={video} type='video/mp4' />
              </video>
              <i
                style={{
                  position: 'absolute',
                  bottom: '2px',
                  right: '4px',
                  color: '#FFFFFF',
                  cursor: 'pointer',
                }}
                tabIndex={-1}
                role='button'
                className={`fas fa-${scrollerOpen ? 'angle-up' : 'angle-down'}`}
                onClick={this.toggleScrollerOpen.bind(this)}
              />
              <div className='row'>
                <div className='col-5 left-column justify-content-center d-flex'>
                  <div className='align-self-top' style={{ textAlign: 'center' }}>
                    <h2><NumberFormat value={stats.events} displayType='text' thousandSeparator /></h2>
                    <h3>Events Detected and Analyzed</h3>
                  </div>
                </div>
                <div className='col-5 middle-column justify-content-center d-flex'>
                  <div className='align-self-top' style={{ textAlign: 'center' }}>
                    <h2><NumberFormat value={stats.suspects} displayType='text' thousandSeparator /></h2>
                    <h3>Suspects Identified and Filtered</h3>
                  </div>
                </div>
                <div className='col-2 right-column justify-content-center d-flex'>
                  <div className='align-self-top' style={{ textAlign: 'center' }}>
                    <h2><NumberFormat value={stats.threats} displayType='text' thousandSeparator /></h2>
                    <h3>Threats Identified</h3>
                  </div>
                </div>
              </div>
              <div className='scroller-bg' />
            </div>
            <div className='row main-content' style={{ marginTop: '15px' }}>
              <div className='col-12 left-column'>
                <div className='column-content'>
                  <DataGrid
                    data={events}
                    columnHeaders='eventHeaders'
                    getTdProps={(state, rowInfo) => ({
                      onClick: (e, handleOriginal) => {
                        this.viewDetail(rowInfo.original);
                        if (handleOriginal) {
                          handleOriginal();
                        }
                      },
                      style: {
                        cursor: 'pointer',
                      },
                    })}
                    columns={[{
                      accessor: 'created',
                      Cell: props => moment(props.value).format('MM/DD/YYYY'),
                    }, {
                      accessor: 'identified_at',
                      Cell: props => moment(props.value).format('MM/DD/YYYY'),
                    }, {
                      accessor: 'source',
                    }, {
                      accessor: 'name',
                    }]}
                  />
                </div>
              </div>
            </div>
            <Flyout handleClose={this.closeDetail} isOpen={flyoutEvent ? true : false}>
              <FindingDetail
                event={flyoutEvent || {}}
                assignableUsers={assignableUsers}
                update={this.update}
              />
            </Flyout>
          </div>
        }
      </span>
    );
  }
}

EventsPageView.propTypes = {
  orgId: PropTypes.string.isRequired,
  getState: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  user: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  loading: PropTypes.bool,
  routeToPage: PropTypes.func.isRequired,
};

EventsPageView.defaultProps = {
  user: {},
  payload: {},
  data: {},
  filters: {},
  loading: false,
};

export default EventsPageView;



// WEBPACK FOOTER //
// ./src/views/Pages/EventsPageView.js